// extracted by mini-css-extract-plugin
export default {"topic":"summary_topic__sWAjx","trending_negative":"summary_trending_negative__-EGIX","trending_positive":"summary_trending_positive__MK6ao"};